import Vue from 'vue';
import { getPageInfo } from './api';
import { resolveComponents } from '@/components/templates/helper';
import actComponentLib from './components/actComponentsLib';

export default {
  namespaced: true,
  state() {
    return {
      actData: null,
      tplData: null,
      actCode: null,
      pinnedBtnComponentObjs: [],
      flowComponentObjs: [],
      positionComponentObjs: []
    };
  },
  actions: {
    parseCompnents({ commit }, { metaInfo, actData }) {
      const components = metaInfo.components;
      if (!components || !components.length) {
        return;
      }
      // 拿到 metaInfo 之后直接调 helper.resolveComponents 即可生成组件数组用于渲染
      const [
        pinnedBtnComponentObjs, // pinnedBtnComponentObjs 就是右上角固定按钮组，比较特殊，需要单独提取
        flowComponentObjs, // 流式布局的组件数组
        positionComponentObjs // 固定定位的组件数组
      ] = resolveComponents(components, { actData, actComponentLib });
      commit('setComponentObjs', {
        pinnedBtnComponentObjs,
        flowComponentObjs,
        positionComponentObjs
      });
    },
    async getActData({ commit, dispatch }, actCode) {
      Vue.prototype.$hll.showLoading({});
      let actData;
      try {
        actData = await getPageInfo(actCode);
      } catch (error) {
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
      let metaInfo = {};
      try {
        metaInfo = JSON.parse(actData.metaInfo);
      } catch (e) {
        throw new Error('模板数据 parse 出错');
      }
      if (!actData.taskInfos) {
        actData.taskInfos = [];
      }
      commit('setActData', actData);
      commit('setTplData', metaInfo);
      // 解析组件
      dispatch('parseCompnents', { metaInfo, actData });
    }
  },
  mutations: {
    setTplData(state, val) {
      state.tplData = val;
    },
    setActData(state, val) {
      state.actData = val;
    },
    setComponentObjs(
      state,
      { pinnedBtnComponentObjs, flowComponentObjs, positionComponentObjs }
    ) {
      state.pinnedBtnComponentObjs = pinnedBtnComponentObjs;
      state.flowComponentObjs = flowComponentObjs;
      state.positionComponentObjs = positionComponentObjs;
    },
    initSetActCode(state, actCode) {
      state.actCode = actCode;
    }
  }
};
